import React, { useState } from "react";
import imageCompression from "browser-image-compression";
import api, { fileUrl } from "@/lib/api";
import { Upload, X, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ImageUpload({ label, value, onChange, testId }) {
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const compressed = await imageCompression(file, {
        maxSizeMB: 0.8,
        maxWidthOrHeight: 1400,
        useWebWorker: true,
      });
      const fd = new FormData();
      fd.append("file", compressed, file.name);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.path);
      toast.success("Foto subida");
    } catch (err) {
      toast.error("No se pudo subir la foto");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <label className="text-sm text-grises-600 mb-1.5 block">{label}</label>
      {value ? (
        <div className="relative rounded-xl overflow-hidden border border-grises-200 group aspect-[4/3] bg-grises-50">
          <img src={fileUrl(value)} alt={label} className="w-full h-full object-cover" />
          <button
            type="button"
            data-testid={`${testId}-remove`}
            onClick={() => onChange("")}
            className="absolute top-2 right-2 bg-negro/70 text-blanco rounded-full p-1.5 opacity-0 group-hover:opacity-100 transition-opacity"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      ) : (
        <label
          data-testid={testId}
          className="flex flex-col items-center justify-center aspect-[4/3] border-2 border-dashed border-grises-300 rounded-xl cursor-pointer hover:border-borgona-500 hover:bg-borgona-50/40 transition-colors"
        >
          {uploading ? (
            <Loader2 className="w-6 h-6 text-borgona-500 animate-spin" />
          ) : (
            <>
              <Upload className="w-6 h-6 text-grises-400 mb-2" />
              <span className="text-xs text-grises-500">Subir foto</span>
            </>
          )}
          <input type="file" accept="image/*" className="hidden" onChange={handleFile} disabled={uploading} />
        </label>
      )}
    </div>
  );
}
